export default "__VITE_ASSET__LEzCu9w2__"